/**
 * Composant pour afficher les statistiques du tableau de bord
 */
import React from 'react';
import { Appointment } from '../types';

interface DashboardStatsProps {
  appointments: Appointment[];
  todayAppointments: Appointment[];
  upcomingAppointments: Appointment[];
  smsCredits: number;
}

/**
 * Composant pour afficher les statistiques du tableau de bord
 */
const DashboardStats: React.FC<DashboardStatsProps> = ({
  appointments,
  todayAppointments,
  upcomingAppointments,
  smsCredits
}) => {
  return (
    <div className="dashboard-stats">
      <div className="stat-card">
        <h3>Total des rendez-vous</h3>
        <p className="stat-value">{appointments.length}</p>
      </div>
      <div className="stat-card">
        <h3>Aujourd'hui</h3>
        <p className="stat-value">{todayAppointments.length}</p>
      </div>
      <div className="stat-card">
        <h3>À venir</h3>
        <p className="stat-value">{upcomingAppointments.length}</p>
      </div>
      <div className="stat-card sms-credits">
        <h3>Crédits SMS</h3>
        <p className="stat-value">{smsCredits}</p>
        <p className="stat-description">SMS restants pour les rappels</p>
      </div>
    </div>
  );
};

export default DashboardStats;
